import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const Subhead = ({ children, level, hideOverflow, className, qaId }) => {
  const subheadClasses = classNames({
    'uni-subhead': level === 'default',
    'uni-subhead--small': level === 'small' || level === 'subtle',
    'uni-subhead--subtle': level === 'subtle',
    'u-text-overflow': hideOverflow,
    [className]: className,
  });

  return (
    <h4 className={subheadClasses} data-qa-id={qaId}>
      {children}
    </h4>
  );
};

Subhead.propTypes = {
  children: PropTypes.string,
  level: PropTypes.oneOf(['default', 'small', 'subtle']),
  hideOverflow: PropTypes.bool,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

Subhead.defaultProps = {
  level: 'default',
  className: '',
};

export default Subhead;



// WEBPACK FOOTER //
// ./src/type/subhead/index.jsx